import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { OAuthService } from "common";
import { Observable, of, throwError } from "rxjs";
import { catchError, switchMap, defaultIfEmpty } from "rxjs/operators";

@Injectable({
    providedIn: 'root',
})
export class BOAuthGuard implements CanActivate {

    constructor(private oauthService: OAuthService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if(!this.oauthService.authenticated) {
        return this.oauthService.refreshAuthToken().pipe(
            switchMap((accessToken) => {
                return of(!!accessToken);
            }),
            defaultIfEmpty(false),
            catchError(err => throwError(() => err))
        );
        }
        this.oauthService.restartIdleTimer();
        return !!this.oauthService.authenticated;
    }
}